var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.748 8.57922L0.749912 8.57922C0.551025 8.57922 0.360283 8.50021 0.219648 8.35958C0.0790139 8.21895 7.67757e-06 8.0282 7.69495e-06 7.82932C7.71234e-06 7.63043 0.0790139 7.43969 0.219648 7.29905C0.360283 7.15842 0.551026 7.07941 0.749912 7.07941L15.748 7.07941C15.9469 7.07941 16.1376 7.15842 16.2783 7.29905C16.4189 7.43969 16.4979 7.63043 16.4979 7.82932C16.4979 8.02821 16.4189 8.21895 16.2783 8.35958C16.1376 8.50022 15.9469 8.57922 15.748 8.57922Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 7.82935L9.21782 1.61113C9.07701 1.47032 8.9979 1.27934 8.9979 1.0802C8.9979 0.881059 9.07701 0.690077 9.21782 0.549264C9.35863 0.408452 9.54962 0.329346 9.74875 0.329346C9.94789 0.329346 10.1389 0.408452 10.2797 0.549264L17.0288 7.29841C17.0987 7.36807 17.1541 7.45083 17.1919 7.54193C17.2297 7.63304 17.2491 7.73071 17.2491 7.82935C17.2491 7.92798 17.2297 8.02565 17.1919 8.11676C17.1541 8.20787 17.0987 8.29062 17.0288 8.36028L10.2797 15.1094C10.1389 15.2502 9.94789 15.3293 9.74875 15.3293C9.54961 15.3293 9.35863 15.2502 9.21782 15.1094C9.07701 14.9686 8.9979 14.7776 8.9979 14.5785C8.9979 14.3794 9.07701 14.1884 9.21782 14.0476L15.4375 7.82935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.499f6cafa4c4aaea4bdb01d41f538f6a.svg";
export { ForwardRef as ReactComponent };